"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RetailersList = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _RetailerOption = require("../RetailerOption");

var _react = require("react");

var _axios = _interopRequireDefault(require("axios"));

var _jsxRuntime = require("react/jsx-runtime");

var RetailersList = function RetailersList(_ref) {
  var retailers = _ref.retailers,
      article = _ref.article,
      id = _ref.id;

  var _useState = (0, _react.useState)({}),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      services = _useState2[0],
      setServices = _useState2[1];

  (0, _react.useEffect)(function () {
    if (article) setServices(article.statusByRetailer);
  }, [article]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    id: id,
    children: retailers.map(function (retailer, i) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RetailerOption.RetailerOption, {
        retailer: retailer,
        services: services
      }, i);
    })
  });
};

exports.RetailersList = RetailersList;